import { Parallax } from "react-scroll-parallax";
import ContactForm from "../contact-form/ContactForm";
import EmbedMap from "./EmbedMap";
import FooterNav from "./FooterNav";
import SocialIcons from "./SocialIcons";
import { FaLocationDot, FaPhone } from "react-icons/fa6";
import styles from "./Footer.module.css";

const FOOTER_BG_URL =
  "https://static.vecteezy.com/system/resources/previews/007/073/820/non_2x/wooden-table-and-blur-of-beauty-sunset-sky-and-mountains-as-background-free-photo.jpg";

function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer id="contactUs" className={`container-fluid g-0 parallax-wrapper ${styles.footer}`}>
      <Parallax
        speed={-25}
        easing="easeInOut"
        className="parallax-background"
        style={{
          backgroundImage: `url("${FOOTER_BG_URL}")`,
        }}
      />

      <div className="overlay" />

      <div className="row g-0 w-100">
        <section className="col-12 col-md-5 d-flex justify-content-center align-items-center">
          <ContactForm />
        </section>

        <section className={`col-12 col-md-3 ${styles.siteMapSection}`}>
          <h4 className={styles.sectionTitle}>Site Map</h4>
          <FooterNav />
        </section>

        <section className={`col-12 col-md-4 ${styles.contactSection}`}>
          <h4 className={styles.sectionTitle}>Contact Information</h4>

          <address className={styles.address}>
            <div className={styles.contactRow}>
              <FaPhone aria-hidden="true" />
              <a href="tel:+19493289951">(949) 328-9951</a>
            </div>

            <div className={styles.contactRow}>
              <FaLocationDot aria-hidden="true" />
              <span>
                28083 Moulton Pkwy Unit C-4
                <br />
                Laguna Niguel, CA 92677
              </span>
            </div>
          </address>

          <EmbedMap />
          <SocialIcons />

          <p className={styles.copyright}>
            © Alo Asian Kitchen, {currentYear}. All rights reserved.
          </p>
        </section>

        <small className={styles.credit}>
          Footer background:{" "}
          <a
            href="https://www.vecteezy.com/free-photos/background"
            target="_blank"
            rel="noopener noreferrer"
          >
            Background Stock photos by Vecteezy
          </a>
        </small>
      </div>
    </footer>
  );
}

export default Footer;